<template>
  <transition name="voucher-package">
    <div class="modal-mask">
      <div class="modal-container">
        <div v-if="dataList.length > 0" class="modal-body">
          <div class="movie-popup-wrap">
            <p class="movie-popup-tit">{{title}}</p>
            <div class="movie-list-wrap">
              <template v-if="dataList.length > 0">
                <div v-for="(data, index) in getPackgeList" :key="index" class="movie-list">
                  <span class="vod-img">
                    <img :src="'https://' + data.image" alt=""/>
                    <!-- 추천  -->
                    <!--<icons-movie v-if="iconArr.length > 0" :icons="iconArr" />-->

                    <!-- 패키지영화 자세히 보기 팝업에서 사용되는 아이콘 -->
                    <!--<icons-movie v-else-if="data.marks.length > 0" :icons="data.marks" />-->

                    <!-- 관람가  -->
                    <!--<age-limits :targetAge="+data.targetage" :contentType="'movie'" />-->
                    <div class="tag-top tag-list" v-top-tag-list="topTag(data.marks)"></div>
                    <!--<div class="tag-top tag-list" v-top-tag-list="cell.top_taglist">sss</div>-->
                    <div class="tag-bottom tag-list" v-bottom-tag-list="bottomTag(data.marks)"></div>
                  </span>
                  <span class="thumb-text-wrap">
                    <span class="thumb-text-right">
                      <strong class="thumb-title">{{data.title}}</strong>
                    </span>
                  </span>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="modal-footer popup-close">
          <button class="modal-default-button" @click="setPackagePopupClose()">
            <img src="/img/common/btn-close-white.png" class="btn-close-white" alt="팝업닫기"/>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// import AgeLimits from '../model/AgeLimits';
// import IconsMovie from '../model/IconsMovie';
import { EventBus } from '@/components/lnb/voucher/VoucherEventBus'
// import { topTagList } from '@/common/directives'
import { topTagList, bottomTagList } from '@/common/directives'
import { intersectionWith } from 'lodash'
import { enableBodyScroll } from '@/common/util/ui.utils'
export default {
  components: {
    // AgeLimits,
    // IconsMovie
  },
  props: {
    dataList: {
      type: Array,
      required: true
    },
    title: { // 패키지 더보기 팝업에서 사용되는 전체 title
      type: String,
      required: true
    }
  },
  data () {
    return {
      iconArr: []
    }
  },
  computed: {
    getPackgeList () {
      return this.dataList.filter((data) => {
        if (data.marks) {
          // if (data.marks.eventtype === 'event') this.iconArr.push('event');
          // if (data.marks.recommendtype === 'theater') this.iconArr.push('same');
          // if (data.marks.passtype === 'playy') this.iconArr.push('playy');
          // if (data.marks.translator === 'subtitle') this.iconArr.push('subtitle');
          // if (data.marks.translator === 'dubbing') this.iconArr.push('dubbing');
        }
        return data
      })
    }
  },
  directives: {
    topTagList, bottomTagList
  },
  methods: {
    setPackagePopupClose () {
      EventBus.$emit('setPackagePopupClose')
    },
    topTag (tags) {
      let tagArr = ['discount', 'payback', 'event', 'reserve']
      let compare = intersectionWith(tags, tagArr)
      if (compare.length > 0) {
        return compare
      }
    },
    bottomTag (tag) {
      return tag.indexOf('playy') > -1 ? ['playy'] : ''
    },
    scrollEvent (e) {
      if (e.target.scrollTop <= 0) {
        e.target.scrollTop = 1
      } else if (e.target.scrollTop === e.target.scrollHeight - e.target.clientHeight) {
        e.target.scrollTop = e.target.scrollTop - 1
      }
    }
  },
  mounted () {
    if (document.querySelector('.modal-mask').scrollTop === 0) {
      document.querySelector('.modal-mask').scrollTop = 1
    }
    document.querySelector('.modal-mask').addEventListener('scroll', this.scrollEvent)
  },
  beforeDestroy () {
    enableBodyScroll()
    document.querySelector('.modal-mask').addEventListener('scroll', this.scrollEvent)
  }
}

</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
  }

  .modal-container {
    transition: all .3s ease;
  }

  .movie-popup-wrap {
    width: 270px;
    margin: 0 auto;
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .movie-popup-tit {
    font-weight: 700;
    font-size: 18px;
    letter-spacing: -0.3px;
    text-align: center;
    color: #fff;
    padding: 20px 0;
  }

  /*.movie-list:first-child{*/
  /*  margin-right: 10px;*/
  /*}*/

  .movie-list {
    display: inline-block;
    text-align: center;
    width: 130px;
    margin: 0 5px 20px 0;
    /*margin-bottom: 20px;*/
  }

  .vod-img {
    position: relative;
    display: block;
  }
  .vod-img img {
    width: 130px;
  }
  .vod-img .tag-top{
    position: absolute;
    top: 5px;
    left: 5px;
  }

  .thumb-text-wrap {
    display: table;
    width: 100%;
    padding-top: 7px;
    table-layout: fixed;
  }

  .thumb-text-right {
    display: table-cell;
  }

  .movie-popup-wrap .thumb-title {
    text-align: left;
    white-space: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    font-size: 13px;
    color: #fff;
  }

  .modal-default-button {
    position: absolute;
    width: 36px;
    height: 36px;
    right: 0;
    top: 0;
  }
  .modal-default-button img{
    width: 36px;
    height: 36px;
  }

  .voucher-package-enter-active, .voucher-package-leave-active {
    transition: opacity .5s
  }

  .voucher-package-enter, .voucher-package-leave-to { /* .fade-leave-active below version 2.1.8 */
    opacity: 0
  }
  .tag-top span {
    margin-bottom: 5px;
  }
</style>
